import { Box, Typography } from "@mui/material";
import FaqComponent from "./FaqQuestions";
import JoinUs from "./JoinUsButton";

export default function Faq({faq,prof}){
    return(
      <Box
        component="section"
        sx={{
          my: { xs: 5, md: 8 },
          p: { xs: 2.2, sm: 3, md: 4.5 },
          borderRadius: { xs: "24px", md: "30px" },
          background: "linear-gradient(145deg, #f3f8fc 0%, #edf5fa 100%)",
          border: "1px solid #dce9f3",
        }}
      >
        <Typography
          component="h2"
          sx={{
            mb: .8,
            textAlign: "center",
            fontFamily: "Assistant",
            fontWeight: 800,
            fontSize: { xs: "1.75rem", md: "2.3rem" },
            color: "#173c5d",
          }}
        >
          שאלות נפוצות
        </Typography>
        <Typography
          sx={{
            mb: 3,
            textAlign: "center",
            fontFamily: "Assistant",
            color: "#657e91",
          }}
        >
          כל מה שכדאי לדעת לפני שמתחילים
        </Typography>
        <FaqComponent faq={faq}/>
        <Box sx={{ mt: 3.5 }}>
          <JoinUs prof={prof} text={"הצטרף עכשיו"}/>
        </Box>
      </Box>
    );
}
